module.exports = __webpack_public_path__ + "_assets/img/user-a.c76813eb.svg";